import {checkIsMobile, getUserInfo} from "../tools/utils";
import {clearStorage} from "../tools/storage";
import frtRouterMeta from "../views/front/router/routerMeta";
import {commonConfig} from "../config/common";
// graphql相关

// 拉取数据
export async function queryHdl(query, variables = {}) {
  try {
    const response = await this.$apollo.query({
      query: query,
      variables: {...variables, ...getUserInfo()},
      fetchPolicy: "network-only"
    });
    // console.log(JSON.stringify(response));
    if (JSON.stringify(response).includes('"code":430')) {
      clearStorage();
      window.vtToast && vtToast("登录失效");
      window.UILoader && this.$router.push({name: frtRouterMeta.login.name})
    }
    return response.data

  } catch (error) {
    console.error(error);
    throw new Error(error)
  }
}

//提交数据
export async function mutationHdl(mutation, variables = {}, notLogin = false) {
  const loginInfo = notLogin ? {} : getUserInfo();
  try {
    const response = await this.$apollo.mutate({
      mutation: mutation,
      variables: {
        ...variables,
        ...loginInfo,
        source: checkIsMobile() ? commonConfig.optSources.app : commonConfig.optSources.web,
      },
    });
    // console.log(response);
    return response.data

  } catch (error) {
    console.error(error);
    throw new Error(error)
  }
}
